'use client';

import { useData } from '@/components/context/data-context';

export default function UserGreeting() {
  const { data } = useData();

  return (
    <span className="text-aareal-aval">Willkommen, {data?.immutableData.firstTenant.name} </span>
  );
}
